import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import IconLine from "./icon-line.svg";

export const StyledIconLine = styled(IconLine)`
  inline-size: 100%;
  block-size: 100%;
  margin-inline: 16px;
`;

export const Container = styled.div`
  display: flex;

  block-size: 100%;
`;

export const TitleAndSummaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  padding-block-end: 8px;

  border-block-end: 1px solid #001246;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: column;
    justify-content: unset;
    align-items: flex-start;

    padding-block-end: 0;
    padding-inline-end: 16px;
    border-block-end: 0;
    border-inline-end: 1px solid #001246;
  }
`;

export const Title = styled.span`
  display: flex;
  gap: 8px;
  align-items: center;

  color: #4585ff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const Summary = styled.div`
  color: #001246;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  text-align: start;
`;
